import Vue from 'vue';

export default Vue.component('selectlist', {
    template:`
    <fragment>
        <label class="font-size-sm" :for="inputId" v-if="settings.label">{{ settings.label }}</label>
        <select :class="['form-control', classes]" @change="update" :value="value" style="width: auto">
            <option v-for="item in settings.items" :value="item.id" :selected="isSelected(item)">{{ item.text }}</option>
        </select>
    </fragment>
    `,
    props:{
        id: { 
            type: String, 
            default: null 
        },
        classes: { 
            type: String, 
            default: null 
        },
        value: { 
            type: [String, Number], 
            default: null 
        },
        settings: {
            type: Object,
            default: null
        }
    },
    computed:{
        inputId() {
            return this.id !== null ? `select-${this.id}` : `select-${this._uid}`;
        }
    },
    methods:{
        isSelected(item){
            return item.id === this.value;
        },
        update(event) {
            this.$emit('input', event.target.value);
        }
    }
});